// extracted by mini-css-extract-plugin
module.exports = {"Registration":"Registration_Registration__2i9VD","Main":"Registration_Main__3rElo"};